import React, { useState } from 'react';
import * as Yup from 'yup';
import { Form, Button, Row, Col, Modal } from 'react-bootstrap';
import { useFormik } from 'formik';
import { alertError, alertSuccess } from '../../helpers/errorHandling';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import adminApi from '../../services/adminApi'; // Replace axios with adminApi

const CampaignTypeForm = ({
  campaignType = null,
  show,
  handleClose,
  onSave,
}) => {
  const { user } = useSelector((state) => state?.user || {});
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: campaignType?.name || '',
      description: campaignType?.description || '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Campaign name is required'),
      description: Yup.string().required('Description is required'),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        if (campaignType?._id) {
          // Update existing campaign type
          await adminApi.post(
            `${process.env.REACT_APP_PROMOTION_API_SERVICE_BASE_URL}api/v1/campaign-types`,
            {
              ...values,
              _id: campaignType?._id,
              organizationId:
                campaignType?.OrganizationId ||
                user?.dashboardSettings?.organizationId,
            }
          );
        } else {
          // Create new campaign type
          await adminApi.post(
            `${process.env.REACT_APP_PROMOTION_API_SERVICE_BASE_URL}api/v1/campaign-types`,
            {
              ...values,
              organizationId: user?.dashboardSettings?.organizationId,
            }
          );
        }

        onSave();
        alertSuccess('Campaign type saved successfully');
        //  if (onSave) onSave(values);
        handleClose();
      } catch (e) {
        console.error(e);
        alertError('Failed to save campaign type, please try again');
      } finally {
        setLoading(false);
      }
    },
  });

  const { values, handleChange, handleBlur, touched, errors, handleSubmit } =
    formik;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {campaignType ? 'Edit Campaign Type' : 'Create Campaign Type'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate onSubmit={handleSubmit}>
          <Row>
            <Col md={12}>
              <Form.Group controlId="name" className="mb-3">
                <Form.Label>Campaign Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.name && !!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group controlId="description" className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={values.description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.description && !!errors.description}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.description}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-end mt-3">
            <Button
              type="button"
              variant="secondary"
              onClick={handleClose}
              className="me-2"
            >
              Cancel
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? 'Saving...' : 'Save'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
      {/* <ToastContainer /> */}
    </Modal>
  );
};

export default CampaignTypeForm;
